import { toLocationSpecificOffers } from "./helpers";
import { LocationSpecificOffer } from "./types";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { OffersFromApi } from "types/api/exclusive_offers";
import { useOffersPaths } from "src/utils/useRemoteOffers";

export function useLocationSpecificOffers(
  exclusiveOffers: OffersFromApi[]
): LocationSpecificOffer[] {
  const language = useLanguage();
  const offersPathMapping = useOffersPaths(language);

  const locationSpecificOffer = toLocationSpecificOffers(
    exclusiveOffers,
    language,
    offersPathMapping
  );

  return locationSpecificOffer;
}
